/*
 * @Description: 用户相关接口
 */
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { UserInfoModel, Users, UserToken, UserMenuModel, UserListModel, UserListPageSearchModel, UserAppUpdateModel, UserAppDeleteModel } from '@/model/userModel'
import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'
import { Route } from '@/constant/route'

const baseUrl = Route.user

export const loginRequest = (userInfo: RequestParams) => {
  return https().request<RootObject<UserToken>>(baseUrl.concat('/login/token'), Method.POST, userInfo, ContentType.form)
}

export const userInfoRequest = () => {
  return https().request<RootObject<UserInfoModel>>(baseUrl.concat('/current/user'), Method.GET, undefined, ContentType.form)
}

export const getCurrentUserMenu = () => {
  return https().request<RootObject<UserMenuModel[]>>('/base/current/user/menu', Method.GET, undefined, ContentType.form)
}

export const getUsers = (user: any) => {
  return https().request<RootObject<Users>>('getUser', Method.GET, user, ContentType.form)
}

/**
 * 搜索分页数据
 */
export const pageSearchUserList = (param: UserListPageSearchModel) => {
  return https().request<RootObject<PageRespModel<UserListModel>>>(baseUrl.concat('/user'), Method.GET, param, ContentType.form)
}

/**
 * 更新数据
 */
export const updateAppUser = (param: UserAppUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/user/app/update'), Method.POST, param, ContentType.form)
}

/**
 * 删除数据
 */
export const deleteByUserId = (param: UserAppDeleteModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/user/logoff/userid'), Method.POST, param, ContentType.form)
}
